module.exports = __webpack_public_path__ + "static/media/ap-web-pdp.88c34afa.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/invitations/single-sample-modal/ap-web-pdp.svg
// module id = 1273
// module chunks = 68